<div class="card_body cbody" >
    <div class="canvas_cont" >
        <!-- <div #captureContainer style="display: inline-block; padding: 30px;">
          <canvas #qrCodeCanvas></canvas>
          <div style=" margin-top: 10px;">
              <h4>HGS76JHH
              </h4>
          </div>
        </div> -->
          
      </div>
      <!-- <div class="download_btn">
        <button mat-raised-button color="accent" (click)="downloadQR1()">Download</button>
      </div> -->
  </div>